/* ── COUNTDOWN TIMER ── */
function updateCountdown() {
  var now = new Date();
  var day = now.getDay();
  var daysUntilFri = (5 - day + 7) % 7;
  if (daysUntilFri === 0 && now.getHours() >= 0) daysUntilFri = 0;
  var nextFriday = new Date(now);
  nextFriday.setDate(now.getDate() + daysUntilFri);
  nextFriday.setHours(23, 59, 59, 999);
  var diff = nextFriday - now;
  if (diff < 0) diff += 7 * 24 * 60 * 60 * 1000;
  var d = Math.floor(diff / (1000*60*60*24));
  var h = Math.floor((diff % (1000*60*60*24)) / (1000*60*60));
  var m = Math.floor((diff % (1000*60*60)) / (1000*60));
  var s = Math.floor((diff % (1000*60)) / 1000);
  var parts = [];
  if (d > 0) parts.push(d + 'D');
  parts.push(String(h).padStart(2,'0') + 'H');
  parts.push(String(m).padStart(2,'0') + 'M');
  parts.push(String(s).padStart(2,'0') + 'S');
  var timer = document.getElementById('countdown-timer');
  var banner = document.getElementById('countdown-banner');
  var label = document.getElementById('countdown-label');
  if (!timer) return;
  timer.textContent = parts.join(' ');
  var totalHours = d * 24 + h;
  if (totalHours < 2) {
    timer.style.color = '#ff4444';
    timer.style.animation = 'badgePulse 0.8s infinite';
    if (label) label.textContent = '⚠️ Last chance! Order closes in ';
    if (banner) banner.style.background = 'rgba(80,10,10,0.97)';
  } else if (totalHours < 24) {
    timer.style.color = '#ff9944';
    if (label) label.textContent = 'Closing soon — order closes Friday midnight · ';
    if (banner) banner.style.background = 'rgba(60,25,5,0.97)';
  } else {
    timer.style.color = 'var(--amber)';
    if (label) label.textContent = 'Order closes Friday midnight · ';
    if (banner) banner.style.background = '';
  }
}
if (document.getElementById('countdown-timer')) {
  updateCountdown();
  setInterval(updateCountdown, 1000);
}

/* ── SCROLL FADE IN ── */
function initFadeIn() {
  if (window.Shopify && window.Shopify.designMode) {
    document.querySelectorAll('.fade-in').forEach(function(el) { el.classList.add('visible'); });
    return;
  }
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) { e.target.classList.add('visible'); observer.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.fade-in').forEach(function(el) { observer.observe(el); });
  document.querySelectorAll('.step-num').forEach(function(el, i) { el.style.animationDelay = (i * 0.8) + 's'; });
}
document.addEventListener('DOMContentLoaded', initFadeIn);
document.addEventListener('shopify:section:load', function() {
  document.querySelectorAll('.fade-in').forEach(function(el) { el.classList.add('visible'); });
});

/* ── SHARE MENU ── */
function shareMenu() {
  var url = window.location.href.split('#')[0] + '#menu';
  if (navigator.share) {
    navigator.share({ title: "This Week's Fuel — Hogan's Meal Prep", url: url });
  } else {
    navigator.clipboard.writeText(url).then(function() {
      var el = document.getElementById('share-confirm');
      if (el) { el.style.opacity = '1'; setTimeout(function() { el.style.opacity = '0'; }, 3000); }
    });
  }
}

/* ── SHOPIFY CART ── */
var hoganCart = {};

function changeQty(e, variantId, cardId, dir) {
  e.stopPropagation();
  e.preventDefault();
  var card = e.target.closest('.menu-card');
  if (card) {
    card.classList.add('no-flip');
    clearTimeout(card._flipTimer);
    card._flipTimer = setTimeout(function() { card.classList.remove('no-flip'); }, 2000);
  }
  if (!hoganCart[variantId]) hoganCart[variantId] = 0;
  var newQty = Math.max(0, hoganCart[variantId] + dir);
  hoganCart[variantId] = newQty;
  var qtyEl = document.getElementById('qty-' + cardId);
  if (qtyEl) qtyEl.textContent = newQty;

  if (dir > 0) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function() { updateCartBadge(); });
  } else if (dir < 0 && newQty >= 0) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: newQty })
    }).then(function() { updateCartBadge(); });
  }

  if (dir > 0) {
    var navCart = document.getElementById('nav-cart');
    if (navCart) { navCart.classList.remove('cart-shake'); void navCart.offsetWidth; navCart.classList.add('cart-shake'); }
  }
}

function updateCartBadge() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var badge = document.getElementById('cart-count');
      if (!badge) return;
      if (cart.item_count > 0) {
        badge.textContent = cart.item_count;
        badge.style.display = 'flex';
      } else {
        badge.style.display = 'none';
      }
    });
}

/* ── AUTO FLIP CARDS ── */
document.addEventListener('DOMContentLoaded', function() {
  var cards = document.querySelectorAll('.menu-card');
  if (!cards.length) return;
  var current = 0;
  var paused = false;
  cards.forEach(function(card) {
    card.addEventListener('mouseenter', function() { paused = true; clearActive(); });
    card.addEventListener('mouseleave', function() { paused = false; });
  });
  function clearActive() { cards.forEach(function(c) { c.classList.remove('auto-flip'); }); }
  setInterval(function() {
    if (paused) return;
    clearActive();
    cards[current].classList.add('auto-flip');
    setTimeout(function() {
      if (!paused) cards[current].classList.remove('auto-flip');
      current = (current + 1) % cards.length;
    }, 2000);
  }, 3500);
});

/* ── FLOATING BUTTONS SCROLL ── */
function setupFloatScroll(id, showAt) {
  var el = document.getElementById(id);
  if (!el) return;
  el.style.opacity = '0';
  el.style.transform = 'translateY(10px)';
  el.style.transition = 'opacity 0.3s, transform 0.3s';
  window.addEventListener('scroll', function() {
    if (window.scrollY > (showAt || 300)) {
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
    } else {
      el.style.opacity = '0';
      el.style.transform = 'translateY(10px)';
    }
  }, { passive: true });
  el.onmouseover = function() { this.style.transform = 'translateY(0) scale(1.1)'; };
  el.onmouseout  = function() { this.style.transform = 'translateY(0) scale(1)'; };
}
setupFloatScroll('float-whatsapp');
setupFloatScroll('float-insta');
setupFloatScroll('float-btn');

/* ── COOKIE BANNER ── */
(function() {
  var consent = localStorage.getItem('hogan_cookie_consent');
  var banner = document.getElementById('cookie-banner');
  if (consent && banner) banner.style.display = 'none';
})();
function acceptCookies() { localStorage.setItem('hogan_cookie_consent', 'all'); hideBanner(); }
function declineCookies() { localStorage.setItem('hogan_cookie_consent', 'essential'); hideBanner(); }
function hideBanner() {
  var banner = document.getElementById('cookie-banner');
  if (!banner) return;
  banner.style.transform = 'translateY(100%)';
  setTimeout(function() { banner.style.display = 'none'; }, 400);
}

/* ── EMBER PARTICLES ── */
(function() {
  var canvas = document.getElementById('ember-canvas');
  if (!canvas) return;
  var ctx = canvas.getContext('2d');
  var embers = [];
  function resize() {
    var hero = document.getElementById('hero');
    if (!hero) return;
    canvas.width = hero.offsetWidth;
    canvas.height = hero.offsetHeight;
  }
  resize();
  window.addEventListener('resize', resize);
  function randomBetween(a, b) { return a + Math.random() * (b - a); }
  function spawnEmber() {
    embers.push({ x: randomBetween(0, canvas.width), y: canvas.height + 10, size: randomBetween(1.5, 3.5), speedX: randomBetween(-0.6, 0.6), speedY: randomBetween(-1.2, -0.5), alpha: randomBetween(0.5, 0.9), decay: randomBetween(0.003, 0.007), hue: randomBetween(20, 45) });
  }
  function animate() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (Math.random() < 0.25) spawnEmber();
    embers = embers.filter(function(e) { return e.alpha > 0; });
    embers.forEach(function(e) {
      e.x += e.speedX + Math.sin(Date.now() * 0.001 + e.y) * 0.3;
      e.y += e.speedY;
      e.alpha -= e.decay;
      ctx.save();
      ctx.globalAlpha = e.alpha;
      ctx.beginPath();
      ctx.arc(e.x, e.y, e.size, 0, Math.PI * 2);
      ctx.fillStyle = 'hsl(' + e.hue + ',90%,65%)';
      ctx.shadowBlur = 6;
      ctx.shadowColor = 'hsl(' + e.hue + ',90%,65%)';
      ctx.fill();
      ctx.restore();
    });
    requestAnimationFrame(animate);
  }
  animate();
})();

/* ── TYPEWRITER ── */
(function() {
  var el = document.getElementById('typewriter-text');
  if (!el) return;
  var text = 'Healthy never tasted so good.';
  var i = 0;
  var started = false;
  var cursor = '<span style="border-right:2px solid #B9E0F0;margin-left:2px;animation:cursorBlink 0.8s step-end infinite"></span>';
  function type() {
    if (i <= text.length) { el.innerHTML = text.slice(0, i) + cursor; i++; setTimeout(type, 55); }
  }
  var obs = new IntersectionObserver(function(entries) {
    if (entries[0].isIntersecting && !started) { started = true; setTimeout(type, 400); }
  }, { threshold: 0.5 });
  obs.observe(el);
})();

/* ── NUMBER COUNTER ── */
(function() {
  var stats = [
    { id: 'stat-0', target: 300, suffix: '+', duration: 1800 },
    { id: 'stat-1', target: 50,  suffix: 'g', duration: 1200 },
    { id: 'stat-2', target: 100, suffix: '%', duration: 1500 }
  ];
  function animateCount(el, target, suffix, duration) {
    var start = null;
    function step(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var ease = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.floor(ease * target) + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  var triggered = false;
  var obs = new IntersectionObserver(function(entries) {
    if (entries[0].isIntersecting && !triggered) {
      triggered = true;
      stats.forEach(function(s) { var el = document.getElementById(s.id); if (el) animateCount(el, s.target, s.suffix, s.duration); });
    }
  }, { threshold: 0.4 });
  var grid = document.querySelector('.stats-grid');
  if (grid) obs.observe(grid);
})();

/* ── SUBSCRIPTION TIERS ── */
function goToTier(url) {
  if (url && url !== 'blank') window.location.href = url;
}

/* ── REVIEWS CAROUSEL ── */
var currentReview = 0;
var totalReviews = 4;
function goToReview(n) {
  currentReview = n;
  var track = document.getElementById('reviews-track');
  if (track) track.style.transform = 'translateX(-' + (n * 100) + '%)';
  document.querySelectorAll('.dot').forEach(function(d, i) { d.classList.toggle('active', i === n); });
}
function shiftReview(dir) { goToReview((currentReview + dir + totalReviews) % totalReviews); }
if (document.getElementById('reviews-track')) setInterval(function() { shiftReview(1); }, 6000);

/* ── FAQ ── */
function toggleFaq(n) {
  var ans = document.getElementById('faq-a-' + n);
  if (!ans) return;
  var arrow = ans.previousElementSibling.querySelector('.faq-arrow');
  var isOpen = ans.classList.contains('open');
  document.querySelectorAll('.faq-a').forEach(function(a) { a.classList.remove('open'); });
  document.querySelectorAll('.faq-arrow').forEach(function(a) { a.classList.remove('open'); });
  if (!isOpen) { ans.classList.add('open'); if (arrow) arrow.classList.add('open'); }
}

/* ── DELIVERY CHECKER ── */
function checkPostcode() {
  var raw = document.getElementById('postcode-input').value.trim().toUpperCase().replace(/\s+/g, '');
  if (raw.length < 2) { showResult(null, 'Please enter a valid postcode'); return; }
  var match = raw.match(/^([A-Z]{1,2})(\d{1,2})/);
  if (!match) { showResult(false, '✕ Postcode not recognised — please try again'); return; }
  var area = match[1];
  var district = parseInt(match[2]);
  var covered = (area === 'BD' && district >= 1 && district <= 23) || (area === 'HX' && district >= 1 && district <= 7);
  if (covered) { showResult(true, '✓ Great news — we deliver to your area! Order by Friday for Monday delivery.'); }
  else { showResult(false, '✕ Sorry, we don\'t currently deliver to that area. We\'ll be expanding soon!'); }
}
function showResult(success, message) {
  var el = document.getElementById('delivery-result');
  if (!el) return;
  el.style.display = 'block';
  if (success === true)  { el.style.background = 'rgba(100,200,212,0.08)'; el.style.borderColor = 'var(--teal)'; el.style.color = 'var(--teal)'; }
  if (success === false) { el.style.background = 'rgba(200,80,80,0.08)';   el.style.borderColor = '#c84a40';     el.style.color = '#e07060'; }
  if (success === null)  { el.style.background = 'transparent';             el.style.borderColor = 'var(--wood-dark)'; el.style.color = 'var(--muted)'; }
  el.textContent = message;
}
document.addEventListener('DOMContentLoaded', function() {
  var inp = document.getElementById('postcode-input');
  if (inp) inp.addEventListener('keydown', function(e) { if (e.key === 'Enter') checkPostcode(); });
});

/* ── EMAIL SIGNUP ── */
function handleSignup(e) {
  e.preventDefault();
  var msg = document.getElementById('signup-msg');
  if (msg) { msg.textContent = '✦ You\'re on the list — welcome to the family!'; msg.style.opacity = '1'; setTimeout(function() { msg.style.opacity = '0'; }, 5000); }
  document.getElementById('signup-email').value = '';
}
